import {
  CONFIRM_APPROVE_BUILDER,
  CONFIRM_APPROVE_BUILDER_SUCCESS,
  CONFIRM_APPROVE_BUILDER_FAILURE,
} from './actionTypes';

export const confirmApproveBuilder = (confirmBuilderToken, isDeactivate) => ({
  type: CONFIRM_APPROVE_BUILDER,
  confirmBuilderToken,
  isDeactivate,
});

export const confirmApproveBuilderSuccess = () => ({
  type: CONFIRM_APPROVE_BUILDER_SUCCESS,
});

export const confirmApproveBuilderFailure = errMsg => ({
  type: CONFIRM_APPROVE_BUILDER_FAILURE,
  errMsg,
});
